import React from "react";

/**
 * Page section wrapper.
 * tone: default | light | dark     narrow: constrain width     tight: smaller padding
 */
export default function Section({ tone = "default", narrow = false, tight = false, flushTop = false, center = false, id, className = "", children }) {
  const cls = [
    "section",
    tone !== "default" && `section--${tone}`,
    tight && "section--tight",
    flushTop && "section--flush-top",
    className,
  ].filter(Boolean).join(" ");

  return (
    <section id={id} className={cls}>
      <div className={`container${narrow ? " container--narrow" : ""}${center ? " center" : ""}`}>{children}</div>
    </section>
  );
}
